/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/collection-item.js":
/*!****************************************!*\
  !*** ./src/scripts/collection-item.js ***!
  \****************************************/
/***/ (() => {

eval("(() => {\n  if (typeof window.customElements.get('collection-item') !== 'undefined') {\n    return;\n  }\n  window.customElements.define('collection-item', class CollectionItem extends HTMLElement {\n    // eslint-disable-line\n    constructor() {\n      super();\n      this.image = this.querySelector('[data-collection-item-image]');\n      this.swatches = this.querySelectorAll('[data-swatch]');\n      this.allLinks = this.querySelectorAll('[href]');\n      this.initSwatches();\n    }\n    initSwatches() {\n      this.swatches.forEach(swatch => {\n        swatch.addEventListener('click', () => {\n          if (swatch.classList.contains('active')) return;\n          this.updateSwatch(swatch);\n        });\n      });\n    }\n    updateSwatch(selectedSwatch) {\n      const url = selectedSwatch.dataset.url;\n      const id = selectedSwatch.dataset.variantId;\n      const imageUrl = selectedSwatch.dataset.image;\n      this.image.setAttribute('src', imageUrl);\n      this.allLinks.forEach(link => link.setAttribute('href', url));\n      this.swatches.forEach(swatch => swatch.classList.toggle('active', swatch.dataset.variantId === id));\n    }\n  });\n})();\n\n//# sourceURL=webpack://fyidoctors_shopify_theme/./src/scripts/collection-item.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/scripts/collection-item.js"]();
/******/ 	
/******/ })()
;